export const ADD_ROW = "ADD_ROW";
export const GET_ALL_SHEETS = "GET_ALL_SHEETS";
export const DELETE_ROW = "DELETE_ROW";
export const GET_ONE_SHEET = "GET_ONE_SHEET";
export const SET_ERROR = "SET_ERROR";
export const SET_LOADING = "SET_LOADING";
export const ADD_ROW_SUCCESS = "ADD_ROW_SUCCESS";
export const ADD_ROW_FAILURE = "ADD_ROW_FAILURE";
export const SAVE_SHEET = "SAVE_SHEET"
export const UPDATE_SHEET_ROWS = "UPDATE_SHEET_ROWS";
export const UPDATE_ROW_QUANTITY = "UPDATE_ROW_QUANTITY";